
<template>
  <div id="app">
    <Navbar
      v-if="!$route.path.includes('/lockout')"
    />
    <div v-if="screenWidth < 500">
      <SideBarMobile
        v-if="getLoggedInUser.token"
      />
    </div>
    <div v-else>
      <div v-if="client == 'ValdrinSahiti'">
        <SideBarVS v-if="getLoggedInUser.token" />
      </div>
      <div v-else-if="client == 'DonikaLoci'">
        <SideBarDonika
          v-if="getLoggedInUser.token" />
      </div>
      <div v-else-if="client == 'WaloneFashion'">
        <SideBarWalone
          v-if="getLoggedInUser.token"
        />
      </div>
      <div v-else-if="client == 'BliniFashion'">
        <SidebarBlini
          v-if="getLoggedInUser.token"
        />
      </div>
      <div v-else-if="client == 'DibaCelina'">
        <SidebarDibaCelina
          v-if="getLoggedInUser.token"
        />
      </div>
      <div v-else-if="client == 'GoddessFashion'">
        <SidebarGoddess
          v-if="getLoggedInUser.token"
        />
      </div>
      <div v-else-if="client == 'FjollaHaxhismajli'">
        <SidebarFjolla
          v-if="getLoggedInUser.token"
        />
      </div>
      <div v-else>
        <Sidebar
          v-if="getLoggedInUser.token"
        />
      </div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <router-link :to="notificationLink">
      <notifications
        group="foo"
        position="bottom right"
        classes="my-style"
      />
    </router-link>
    <div
      v-if="!getIsLoading"
      style="position:absolute; top: 50%; left: 50%"
    >
      <Spinner style="padding-top: 10% !important ; padding-left: 40%" />
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Sidebar from '@/components/sidebars/Sidebar.vue';
import Navbar from '@/components/Navbar.vue'
import SideBarVS from '@/components/sidebars/SideBarVS.vue'
import SideBarDonika from '@/components/sidebars/SideBarDonika.vue'
import SideBarWalone from '@/components/sidebars/SideBarWalone.vue'
import SideBarMobile from '@/components/sidebars/SideBarMobile.vue'
import SidebarBlini from '@/components/sidebars/SidebarBlini.vue'
import SidebarDibaCelina from '@/components/sidebars/SidebarDibaCelina.vue'
import SidebarGoddess from '@/components/sidebars/SidebarGoddess.vue'
import SidebarFjolla from '@/components/sidebars/SidebarFjolla.vue'

import Swal from 'sweetalert2';
import { client } from '@/domainConfig'
import eventBus from '@/main'
import getConnection from './microsoft-signalR/signalR';
import Spinner from './components/Spinner/Spinner.vue';


export default {
  name: 'Home',
  components: {
    Sidebar,
    Navbar,
    Spinner,
    SideBarVS,
    SideBarDonika,
    SideBarWalone,
    SideBarMobile,
    SidebarBlini,
    SidebarDibaCelina,
    SidebarGoddess,
    SidebarFjolla
  },
  data() {
    return {
      client: client.clientName,
      notificationLink: '',
      notificationCount: 0,
      logoutTimer: null,
      test: process.env.VUE_APP_REGION,
      showModal: false,
      birthdayNotification: '',
      screenWidth: window.innerWidth,
      refreshTokenInterval: null,
    };
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'getIsLoading', 'getUsers']),
  },
  created() {
    eventBus.$on('logout-triggered', this.handleGlobalLogout);
    if (!this.getLoggedInUser.token) {
      this.$router.push('/login');
    } else {
      this.addEventListeners();
      this.$nextTick(() => {
      });
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);

    // Since Refresh Token is not working, we are not using it
    if (this.getLoggedInUser?.token) {
      this.startRefreshTokenInterval(this.$router);
    }

    const connection = getConnection();
    if (connection.state === 'Connected') {
      console.log('SignalR already connected');
    } else {
      connection.start()
        .then(() => { return console.log('SignalR connection started in App.vue') })
        .catch((err) => { return console.error('SignalR connection error:', err) });
    }

    connection.on('sendNotificationCounter', this.handleNotification);
    connection.on('sendCreateNewOrderNotificationAlert', this.handleOrders);
  },
  beforeDestroy() {
    eventBus.$off('logout-triggered', this.handleGlobalLogout);

    // Clear the interval to avoid memory leaks
    if (this.refreshTokenInterval) {
      clearInterval(this.refreshTokenInterval);
    }

    const connection = getConnection();
    connection.off('sendNotificationCounter', this.handleNotification);
    connection.off('sendCreateNewOrderNotificationAlert', this.handleOrders);
    window.removeEventListener('resize', this.handleResize);
    this.removeEventListeners();
  },
  methods: {
    ...mapActions(['logoutUser', 'loadNotifications', 'changeLanguage', 'changeVisibilityOfSidebar', 'incrementNotificationCount', 'changeLoadingtoTrue', 'getUsersPagination', 'refreshToken', 'startRefreshTokenInterval']),
    handleNotification(arg) {
      console.log('sendNotificationCounter received:', arg);
      this.loadNotifications({
        pageNumber: 1,
        pageSize: 15,
      })
      Swal.fire({
        icon: 'success',
        title: this.$t('Notification'),
        text: this.$t('notificationText'),
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    },
    handleOrders(arg) {
      console.log('order created', arg);
      Swal.fire({
        icon: 'success',
        title: this.$t('Notification'),
        text: `${this.$t('NewOrder')}: ${arg} ${this.$t('HasBeenCreated')}`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      this.notificationLink = '/orders-overview/Created';
    },
    // connectToSignalR() {
    // const connection = getConnection();

    //   connection.start()
    //     .then(() => {
    //       console.log('Connection to User Hub Successful');
    //     })
    //     .catch(() => {
    //       console.log('Connection to User Hub Failed');
    //   connection.start()
    //     .then(() => {
    //       console.log('Connection to User Hub Successful');
    //     })
    //     .catch(() => {
    //       console.log('Connection to User Hub Failed');
    //     });
    // },
    // disconnectFromSignalR() {
    //   const connection = getConnection();
    //   connection.stop();
    // },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    startLogoutTimer() {
      this.logoutTimer = setTimeout(() => {
        this.logout();
        this.$router.push('/login');
      }, 7 * 24 * 60 * 60 * 1000); // 1 week
    },
    resetLogoutTimer() {
      clearTimeout(this.logoutTimer);
      this.startLogoutTimer();
    },
    handleGlobalLogout() {
      this.logoutUser()
    },
    logout() {
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('isLoading');
      localStorage.removeItem('language');
      localStorage.removeItem('isOnVacation');

      this.logoutUser().then(() => {
        this.$router
          .push({ path: '/login' })
          .then(() => { this.$router.go() })
      });
    },

    addEventListeners() {
      document.addEventListener('mousemove', this.resetLogoutTimer);
      document.addEventListener('keydown', this.resetLogoutTimer);
    },
    removeEventListeners() {
      document.removeEventListener('mousemove', this.resetLogoutTimer);
      document.removeEventListener('keydown', this.resetLogoutTimer);
    },
  },
};
</script>

<style scoped lang="scss">

@font-face {
  font-family: "DM Sans";
  src: local("DMSans"),
    url(../src/assets/fonts/DMSans-Regular.ttf) format("truetype");
}
</style>
